import {
  Box,
  Button,
  Collapse,
  Divider,
  Flex,
  HStack,
  Icon,
  Input,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import {
  GraduateDetailsDto,
  GraduateGuestDataDto,
  TransferGraduateEntranceDto,
} from "../types";
import * as T from "@/components/table";
import { ChevronTop } from "@/components/icons/topArrowIcon";
import { ChevronDown } from "@/components/icons/downArrowIcon";
import { CirclePlusOutline } from "@/components/icons/plusRounded";
import { RoundTransferHorizontalLinear } from "@/components/icons/transferRounded";
import { Dispatch, useState } from "react";
import { SendEmail } from "@/components/icons/sendEmailIcon";
import { OutlineFileDownload } from "@/components/icons/downloadIcon";
import { OutlineEditNote } from "@/components/icons/editIcon";
import {
  Controller,
  ControllerProps,
  FieldErrors,
  SubmitHandler,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { GuestFormData } from ".";
import { OutlineCantEditNote } from "@/components/icons/cantEditIcon";
import { DeleteIcon } from "@/components/icons/delete";
import { CantDeleteIcon } from "@/components/icons/contDelete";
type DesktopProps = {
  graduates: GraduateDetailsDto;
  register: UseFormRegister<GuestFormData>;
  control: ControllerProps<GuestFormData>["control"];
  handleSubmit: UseFormHandleSubmit<GuestFormData>;
  onSubmit: SubmitHandler<GuestFormData>;
  errors: FieldErrors<GuestFormData>;
  onCollapseToggle: () => void;
  isCollapseOpen: boolean;
  isTransferModal: boolean;
  onOpenTransferModal: () => void;
  onCloseTransfer: () => void;
  isOpenAddInvite: boolean;
  onCloseAddInvite: () => void;
  handleEditGuest: (guest: GraduateGuestDataDto) => void;
  handleNewGuest: () => void;
  registerTransfer: UseFormRegister<TransferGraduateEntranceDto>;
  handleSubmitTrasnfer: UseFormHandleSubmit<TransferGraduateEntranceDto>;
  onSubmitTransfer: SubmitHandler<TransferGraduateEntranceDto>;
  setValueTransfer: UseFormSetValue<TransferGraduateEntranceDto>;
  handleSendEmail: (id: number) => void;
  handleDownloadInvite: (id: number) => void;
  query: string;
  setQuery: Dispatch<React.SetStateAction<string>>;
  filtered: { id: number; name: string }[];
  handleCancelTransfer: () => void;
  handleDeleteGuest: (id: number) => void;
  handlePhoneChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: string) => void
  ) => void;
  phoneMask: (value: string) => string;
};

export const DesktopContent = ({
  graduates,
  register,
  handleSubmit,
  onSubmit,
  errors,
  onCollapseToggle,
  isCollapseOpen,
  isTransferModal,
  onOpenTransferModal,
  onCloseTransfer,
  isOpenAddInvite,
  onCloseAddInvite,
  handleEditGuest,
  handleNewGuest,
  registerTransfer,
  handleSubmitTrasnfer,
  onSubmitTransfer,
  setValueTransfer,
  handleSendEmail,
  handleDownloadInvite,
  handleCancelTransfer,
  query,
  setQuery,
  filtered,
  handleDeleteGuest,
  handlePhoneChange,
  phoneMask,
  control,
}: DesktopProps) => {
  const [isBoxOpen, setIsBoxOpen] = useState(false);

  return (
    <Stack w="100%" p={5}>
      <TableContainer p={2}>
        <Box borderWidth="1px" borderRadius="md" overflow="hidden">
          <Flex
            p="4"
            align="center"
            justify="space-between"
            cursor="pointer"
            onClick={onCollapseToggle}
            bg="neutral.100"
            _hover={{ bg: "neutral.300" }}
          >
            <Text fontWeight="bold" fontSize="24px">
              Informações do Evento
            </Text>
            <Icon as={isCollapseOpen ? ChevronTop : ChevronDown} />
          </Flex>
          <Divider />
          <Collapse in={isCollapseOpen} animateOpacity>
            <Box p="8" bg="neutral.100">
              <Divider borderWidth="1px" />
              <HStack p={2}>
                <Text fontWeight="semibold" minW="15%">
                  Nome Turma
                </Text>
                <Text>{graduates?.event.name}</Text>
              </HStack>
              <Divider borderWidth="1px" />
              <HStack p={2}>
                <Text fontWeight="semibold" minW="15%">
                  Tipo Evento
                </Text>
                <Text>{graduates?.event.type.name}</Text>
              </HStack>
              <Divider borderWidth="1px" />
              <HStack p={2}>
                <Text fontWeight="semibold" minW="15%">
                  Data e Hora
                </Text>
                <Text>
                  {new Date(graduates?.event.date).toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Text>
              </HStack>
              <Divider borderWidth="1px" />
              <HStack p={2}>
                <Text fontWeight="semibold" minW="15%">
                  Local
                </Text>
                <Text>{graduates?.event.local}</Text>
              </HStack>
              <Divider borderWidth="1px" />
              <HStack p={2}>
                <Text fontWeight="semibold" minW="15%">
                  Endereço
                </Text>
                <Text>{graduates?.event.address}</Text>
              </HStack>
              <Divider borderWidth="1px" />
              <HStack p={2}>
                <Text fontWeight="semibold" minW="15%">
                  Início Retirada
                </Text>
                <Text>
                  {new Date(graduates?.event.pickupInitialDate).toLocaleString(
                    "pt-BR",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </Text>
              </HStack>
              <Divider borderWidth="1px" />
              <HStack p={2}>
                <Text fontWeight="semibold" minW="15%">
                  Fim Retirada
                </Text>
                <Text>
                  {new Date(graduates?.event.pickupFinalDate).toLocaleString(
                    "pt-BR",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </Text>
              </HStack>
              <Divider borderWidth="1px" />
            </Box>
          </Collapse>
        </Box>
      </TableContainer>
      <Stack>
        <Box w="100%" p={2}>
          <Table>
            <Thead bgColor="neutral.300">
              <Tr>
                <Th textAlign="center">
                  <Text fontWeight="bold" fontSize="14px" color="black">
                    Nome do Formando
                  </Text>
                </Th>
                <Th textAlign="center">
                  <Text fontWeight="bold" fontSize="14px" color="black">
                    E-mail
                  </Text>
                </Th>
                <Th textAlign="center">
                  <Text fontWeight="bold" fontSize="14px" color="black">
                    CPF
                  </Text>
                </Th>
                {graduates?.entrancesRelation.map((ent) => (
                  <Th textAlign="center" key={ent.id}>
                    <Text fontWeight="bold" fontSize="14px" color="black">
                      {ent.eventEntrance.type}
                    </Text>
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              <T.Body key={graduates?.id}>
                <Td fontSize="16px" textAlign="center">
                  {graduates?.name}
                </Td>
                <Td fontSize="16px" textAlign="center">
                  {graduates?.email}
                </Td>
                <Td fontSize="16px" textAlign="center">
                  {graduates?.cpf}
                </Td>
                {graduates?.entrancesRelation.map((ent) => {
                  const totalUsed = (graduates.guests ?? []).filter(
                    (guest) => guest.entrance.id === ent.eventEntrance.id
                  ).length;
                  return (
                    <Td fontSize="16px" textAlign="center" key={ent.id}>
                      {totalUsed} / {ent.quantityInvitation}
                    </Td>
                  );
                })}
              </T.Body>
            </Tbody>
          </Table>
        </Box>
      </Stack>
      <Stack p={2}>
        <HStack justifyContent="flex-end">
          <Button
            bgColor="secondary.500"
            color="white"
            _hover={{ bgColor: "secondary.300" }}
            minW="225px"
            onClick={onOpenTransferModal}
          >
            <RoundTransferHorizontalLinear color="white" />
            <Text ml={1}>Transferir Convite</Text>
          </Button>
          <Button
            bgColor="secondary.500"
            color="white"
            _hover={{ bgColor: "secondary.300" }}
            minW="225px"
            onClick={handleNewGuest}
          >
            <CirclePlusOutline color="white" />
            <Text ml={1}>Adicionar Convidado</Text>
          </Button>
        </HStack>
        <Modal
          isOpen={isTransferModal}
          onClose={onCloseTransfer}
          closeOnOverlayClick={false}
          isCentered
        >
          <ModalOverlay />
          <ModalContent bgColor="neutral.100">
            <form onSubmit={handleSubmitTrasnfer(onSubmitTransfer)}>
              <ModalHeader>Transferir Convite</ModalHeader>
              <ModalBody>
                <Stack mt={1}>
                  <Text>Nome do Formando Transmissor</Text>
                  <Input
                    type="hidden"
                    value={graduates?.id}
                    {...registerTransfer("fromGraduateId", {
                      valueAsNumber: true,
                    })}
                  />
                  <Input
                    isDisabled
                    value={graduates?.name}
                    bgColor="neutral.300"
                  />
                </Stack>
                <Stack mt={5} position="relative">
                  <Text>Nome do Formando Receptor</Text>
                  <Input
                    placeholder="Insira o nome do formando receptor"
                    bgColor="white"
                    value={query}
                    onChange={(e) => {
                      setQuery(e.target.value);
                      setIsBoxOpen(true);
                    }}
                    onFocus={() => setIsBoxOpen(false)}
                    onClickCapture={() => setIsBoxOpen(true)}
                  />
                  <Input
                    type="hidden"
                    {...registerTransfer("toGraduateId", {
                      valueAsNumber: true,
                    })}
                  />
                  {isBoxOpen && filtered.length > 0 && (
                    <List
                      position="absolute"
                      width="100%"
                      border="1px solid #ddd"
                      maxHeight="150px"
                      overflowY="auto"
                      zIndex={10}
                      mt={20}
                      borderRadius="md"
                      boxShadow="md"
                      bgColor="white"
                    >
                      {filtered.map((u) => (
                        <ListItem
                          key={u.id}
                          p={2}
                          _hover={{ bg: "gray.100", cursor: "pointer" }}
                          onClick={() => {
                            setQuery(u.name);
                            setValueTransfer("toGraduateId", u.id);
                            setIsBoxOpen(false);
                          }}
                        >
                          <Text>{u.name}</Text>
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Stack>
                <Stack mt={5}>
                  <Text>Lote</Text>
                  <Select bgColor="white" {...registerTransfer("entranceId")}>
                    <option value="">Selecione</option>
                    {graduates?.entrancesRelation.map((ent) => (
                      <option
                        key={ent.eventEntrance.id}
                        value={ent.eventEntrance.id}
                      >
                        {ent.eventEntrance.type}
                      </option>
                    ))}
                  </Select>
                </Stack>
                <Stack mt={5}>
                  <Text>Quantidade</Text>
                  <Input
                    type="number"
                    placeholder="Insira a quantidade"
                    bgColor="white"
                    {...registerTransfer("quantity")}
                  />
                </Stack>
              </ModalBody>
              <ModalFooter justifyContent="space-between">
                <Button
                  onClick={handleCancelTransfer}
                  w="48%"
                  border="1px"
                  borderColor="secondary.500"
                  bgColor="white"
                  color="secondary.500"
                  _hover={{
                    bgColor: "secondary.300",
                    borderColor: "secondary.300",
                    color: "white",
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  w="48%"
                  color="white"
                  bgColor="secondary.500"
                  _hover={{ bgColor: "secondary.300" }}
                >
                  Confirmar
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
        <Modal isOpen={isOpenAddInvite} onClose={onCloseAddInvite} isCentered>
          <ModalOverlay />
          <ModalContent bgColor="neutral.100">
            <form onSubmit={handleSubmit(onSubmit)}>
              <ModalHeader>Adicionar Convidado</ModalHeader>
              <ModalBody>
                <Stack mt={1}>
                  <Text>Lote</Text>
                  <Select bgColor="white" {...register("entranceId")}>
                    <option value="">Selecione</option>
                    {graduates?.entrancesRelation.map((ent) => (
                      <option
                        key={ent.eventEntrance.id}
                        value={ent.eventEntrance.id}
                      >
                        {ent.eventEntrance.type}
                      </option>
                    ))}
                  </Select>
                  {errors?.entranceId?.message && (
                    <Text
                      fontFamily="Lato"
                      fontStyle="normal"
                      fontWeight="500"
                      fontSize="11px"
                      lineHeight="18px"
                      color="fail.500"
                    >
                      {errors.entranceId.message}
                    </Text>
                  )}
                </Stack>
                <Stack mt={5}>
                  <Text>Nome do Convidado</Text>
                  <Input
                    placeholder="Insira o nome do convidado"
                    bgColor="white"
                    {...register("name")}
                  />
                  {errors?.name?.message && (
                    <Text
                      fontFamily="Lato"
                      fontStyle="normal"
                      fontWeight="500"
                      fontSize="11px"
                      lineHeight="18px"
                      color="fail.500"
                    >
                      {errors.name.message}
                    </Text>
                  )}
                </Stack>
                <Stack mt={5}>
                  <Text>E-mail</Text>
                  <Input
                    type="email"
                    placeholder="Insira o e-mail do convidado"
                    bgColor="white"
                    {...register("email")}
                  />
                  {errors?.email?.message && (
                    <Text
                      fontFamily="Lato"
                      fontStyle="normal"
                      fontWeight="500"
                      fontSize="11px"
                      lineHeight="18px"
                      color="fail.500"
                    >
                      {errors.email.message}
                    </Text>
                  )}
                </Stack>
                <Stack mt={5}>
                  <Text>Telefone</Text>
                  <Controller
                    name="phone"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Input
                        placeholder="Insira o telefone do convidado"
                        bgColor="white"
                        value={value}
                        onChange={(e) => handlePhoneChange(e, onChange)}
                      />
                    )}
                  />
                  {errors?.phone?.message && (
                    <Text
                      fontFamily="Lato"
                      fontStyle="normal"
                      fontWeight="500"
                      fontSize="11px"
                      lineHeight="18px"
                      color="fail.500"
                    >
                      {errors.phone.message}
                    </Text>
                  )}
                </Stack>
              </ModalBody>
              <ModalFooter justifyContent="space-between">
                <Button
                  onClick={onCloseAddInvite}
                  w="48%"
                  border="1px"
                  borderColor="secondary.500"
                  bgColor="white"
                  color="secondary.500"
                  _hover={{
                    bgColor: "secondary.300",
                    borderColor: "secondary.300",
                    color: "white",
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  w="48%"
                  color="white"
                  bgColor="secondary.500"
                  _hover={{ bgColor: "secondary.300" }}
                >
                  Confirmar
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </Stack>
      <Stack p={2}>
        <Table>
          <Thead bgColor="neutral.300">
            <Tr>
              <Th textAlign="center">
                <Text fontWeight="bold" fontSize="14px" color="black">
                  Nome do Convidado
                </Text>
              </Th>
              <Th textAlign="center">
                <Text fontWeight="bold" fontSize="14px" color="black">
                  E-mail
                </Text>
              </Th>
              <Th textAlign="center">
                <Text fontWeight="bold" fontSize="14px" color="black">
                  Telefone
                </Text>
              </Th>
              <Th textAlign="center">
                <Text fontWeight="bold" fontSize="14px" color="black">
                  Lote
                </Text>
              </Th>
              <Th textAlign="center">
                <Text fontWeight="bold" fontSize="14px" color="black">
                  Retirada
                </Text>
              </Th>
              <Th textAlign="center" w="15%">
                <Text fontWeight="bold" fontSize="14px" color="black">
                  Ações
                </Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {graduates?.guests.map((guest) => {
              const entrance = graduates.entrancesRelation.find(
                (e) => e.eventEntrance.id === guest.entrance.id
              );
              return (
                <T.Body key={guest.id}>
                  <Td fontSize="16px" textAlign="center">
                    {guest.name}
                  </Td>
                  <Td fontSize="16px" textAlign="center">
                    {guest.email}
                  </Td>
                  <Td fontSize="16px" textAlign="center">
                    {phoneMask(guest.phone)}
                  </Td>
                  <Td fontSize="16px" textAlign="center">
                    {entrance?.eventEntrance.type}
                  </Td>
                  <Td fontSize="16px" textAlign="center">
                    {guest.invitationSentAt
                      ? new Date(guest.invitationSentAt).toLocaleString(
                          "pt-BR",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )
                      : "Ainda não Retirado"}
                  </Td>
                  <Td textAlign="center" w="15%">
                    <Tooltip label="Enviar por E-mail">
                      <Button
                        variant="ghost"
                        onClick={() => handleSendEmail(guest.id)}
                      >
                        <SendEmail color="blue" />
                      </Button>
                    </Tooltip>
                    <Tooltip label="Baixar">
                      <Button
                        variant="ghost"
                        onClick={() => handleDownloadInvite(guest.id)}
                      >
                        <OutlineFileDownload color="blue" />
                      </Button>
                    </Tooltip>
                    <Tooltip
                      label={guest.wasSent ? "Convite já enviado" : "Editar"}
                    >
                      <Button
                        variant="ghost"
                        onClick={() => handleEditGuest(guest)}
                        isDisabled={guest.wasSent}
                      >
                        {guest.wasSent ? (
                          <OutlineCantEditNote />
                        ) : (
                          <OutlineEditNote color="blue" />
                        )}
                      </Button>
                    </Tooltip>
                    <Tooltip
                      label={
                        guest.isPresent
                          ? "Convidado já presente"
                          : guest.isGraduate
                          ? "Formando"
                          : "Excluir"
                      }
                    >
                      <Button
                        variant="ghost"
                        onClick={() => handleDeleteGuest(guest.id)}
                        isDisabled={guest.isPresent || guest.isGraduate}
                      >
                        {guest.isPresent || guest.isGraduate ? (
                          <CantDeleteIcon />
                        ) : (
                          <DeleteIcon color="blue" />
                        )}
                      </Button>
                    </Tooltip>
                  </Td>
                </T.Body>
              );
            })}
          </Tbody>
        </Table>
      </Stack>
    </Stack>
  );
};
